import { render, staticRenderFns } from "./Transcript.vue?vue&type=template&id=0ae839d0&"
import script from "./Transcript.vue?vue&type=script&lang=ts&"
export * from "./Transcript.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports